import * as React from 'react';
import ReactDOM from 'react-dom';

import get from 'lodash/get';

import Localize from 'app/src/localize/Localize';
import BaseItemView from 'app/src/views/base/BaseItemView';

import { PaymentCreditDebitRefund } from './PaymentCreditDebitRefund';
// events triggered by a PaymentCreditDebitView
const _Event = {
  CREDIT_REFUND_CANCEL_CLICKED: 'credit:refund:cancel:clicked',
  CREDIT_REFUND_NEW_CARD_CLICKED: 'credit:refund:new:card:clicked',
  CREDIT_REFUND_REFUND_CLICKED: 'credit:refund:refund:clicked',
};

// configure
let View = BaseItemView.extend({
  template: false,
  onRender() {
    ReactDOM.render(<PaymentCreditDebitRefund viewData={this.viewData} ui={this.ui} />, this.el);
  },
  onDestroy() {
    ReactDOM.unmountComponentAtNode(this.el);
  },
  ui: {
    refundToNewCardButton: '#creditRefundOnNewCard',
    cancelButton: '#creditRefundCancel',
    refundButton: 'button.refund-button',
  },

  events: {
    'click @ui.refundButton': 'refundButtonClicked',
  },

  triggers: {
    'click @ui.refundToNewCardButton': _Event.CREDIT_REFUND_NEW_CARD_CLICKED,
    'click @ui.cancelButton': _Event.CREDIT_REFUND_CANCEL_CLICKED,
  },
});

// define
export default class PaymentCreditDebitRefundView extends View {
  static Event() {
    return _Event;
  }

  /**
   * Event handler when a refund button is clicked.  Triggers a refund clicked event
   * with the extracted payment ID of the payment to refund.
   *
   * @param event The DOM event
   */
  refundButtonClicked(event) {
    let $refundButton = $(event.target);
    let paymentID = $refundButton.data('payment-id');

    if (paymentID) {
      this.trigger(_Event.CREDIT_REFUND_REFUND_CLICKED, paymentID);
    }
  }

  /**
   * Disables the "Refund" button for a payment type by payment type ID
   * @param paymentID
   */
  disableRefundButton(paymentID) {
    let $refundButton = $(`button[data-payment-id="${paymentID}"]`);
    $refundButton.prop('disabled', true);
  }
}
